import { CREDITS_SET } from '../types/creditsTypes.js';

export const setCredits = (value) => ({ type: CREDITS_SET, payload: value });
